import mustache from "mustache";
import { BaseCreateRender } from "../../../base/BaseCreateRender";
import template from "./sateliteRangoFechasModalTemplate.html";

mustache.parse(template);

/** Contador para ids únicos por instancia. */
let MODAL_ID = 0;

/** Modal chico (auto-montado sobre `body`) para elegir el rango de fechas en
 *  pantallas angostas (breakpoint del bottom-sheet de Satélite), en vez de
 *  los 2 inputs fusionados que no entran ahí. Sin Confirmar/Cancelar: cada
 *  cambio de fecha notifica en vivo (`onChange`), igual que los inputs de la
 *  fila principal; el único botón es "atrás", que solo cierra. */
export class SateliteRangoFechasModal extends BaseCreateRender {
  /** Id del elemento raíz auto-montado en `body`. */
  protected readonly elementId = "sateliteRangoFechasModal";
  /** Id único de la instancia (para los ids del DOM). */
  private readonly _modalId: number;

  /**
   * @param _desde Valor inicial ("yyyy-mm-dd").
   * @param _hasta Valor inicial ("yyyy-mm-dd").
   * @param _fechaMin Límite inferior seleccionable.
   * @param _fechaMax Límite superior seleccionable.
   * @param _onChange Notifica `(desde, hasta)` en cada cambio de cualquiera
   *   de los dos inputs.
   */
  constructor(
    private readonly _desde: string,
    private readonly _hasta: string,
    private readonly _fechaMin: string,
    private readonly _fechaMax: string,
    private readonly _onChange: (desde: string, hasta: string) => void,
  ) {
    super();
    MODAL_ID += 1;
    this._modalId = MODAL_ID;
  }

  /** HTML del modal: overlay + card con los 2 inputs de fecha. */
  protected getHtml(): string {
    return mustache.render(template, {
      id: this._modalId,
      desde: this._desde,
      hasta: this._hasta,
      fechaMin: this._fechaMin,
      fechaMax: this._fechaMax,
    });
  }

  /** Captura overlay/inputs/botón, cablea eventos y anima la apertura. */
  protected afterInit(element: HTMLDivElement): void {
    this._overlay = element.querySelector<HTMLDivElement>(".sx-modal-overlay");
    this._backBtn = element.querySelector<HTMLButtonElement>(
      '[data-act="back"]',
    );
    this._desdeInput = element.querySelector<HTMLInputElement>(
      `#srf-desde-${this._modalId}`,
    );
    this._hastaInput = element.querySelector<HTMLInputElement>(
      `#srf-hasta-${this._modalId}`,
    );

    this._overlay?.addEventListener("click", this._onOverlayClick);
    this._backBtn?.addEventListener("click", this._onBack);
    this._desdeInput?.addEventListener("change", this._onRangoChange);
    this._hastaInput?.addEventListener("change", this._onRangoChange);

    requestAnimationFrame(() =>
      this._overlay?.classList.add("sx-modal-overlay--open"),
    );
  }

  /** Libera los listeners antes de desmontar el modal. */
  protected beforeDispose(): void {
    this._overlay?.removeEventListener("click", this._onOverlayClick);
    this._backBtn?.removeEventListener("click", this._onBack);
    this._desdeInput?.removeEventListener("change", this._onRangoChange);
    this._hastaInput?.removeEventListener("change", this._onRangoChange);
  }

  private _overlay: HTMLDivElement | null = null;
  private _backBtn: HTMLButtonElement | null = null;
  private _desdeInput: HTMLInputElement | null = null;
  private _hastaInput: HTMLInputElement | null = null;

  /** Cierra el modal solo si el click fue en el backdrop (no en el contenido). */
  private _onOverlayClick = (e: MouseEvent): void => {
    if (e.target === this._overlay) this.dispose();
  };

  private _onBack = (): void => this.dispose();

  private _onRangoChange = (): void => {
    if (!this._desdeInput || !this._hastaInput) return;
    this._onChange(this._desdeInput.value, this._hastaInput.value);
  };
}
